import React from 'react';
import { Skeleton } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-premium';
import { selectRehabResultIsLoading } from '@Selectors/index';

interface SkeletonCellProps {
	id: GridRowId;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	value: any | undefined;
}

export const SkeletonCell = ({ id, value }: SkeletonCellProps) => {
	const isRiskCountLoading = selectRehabResultIsLoading(true);
	let result;

	if (isRiskCountLoading) {
		result = (
			<Skeleton key={id} sx={{ mx: 1 }} width={'90%'} height={'100%'} />
		);
	} else {
		result = value ?? '';
	}

	return result;
};
